import * as ActionPartnerTypes from 'actions/partner';

const defaultState = {};

export default function userActionsCSVReport(state = defaultState, action) {
  switch (action.type) {
  case ActionPartnerTypes.USER_ACTIONS_CSV_REPORT_RECEIVE:
    return action.payload;
  default:
    return state;
  }
}
